let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hG56j")).then(() => parcelRequire('emmAW'));